// src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Personal from "./pages/Personal";
import About from "./pages/AboutMe";
import Playground from "./components/playground/Playground";
import PrivacyNotice from "./pages/terms/PrivacyNotice";
import TermsOfUse from "./pages/terms/TermsOfUse";
import WorkAtThinkMarkets from "./pages/projects/work-at-thinkmarkets";
import WorkAtHoody from "./pages/projects/work-at-hoody";
import WorkAtCointelegraph from "./pages/projects/work-at-cointelegraph";
// 💡 This inner component will live inside the Router and has access to location
function AppContent() {
  const location = useLocation();

  // 👇 Hide Navbar and Footer on these routes
  const hideLayout = location.pathname === "/playground";

  return (
    <>
      <ScrollToTop />
      <div className="app-wrapper">
        {!hideLayout && <Navbar />}

        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/personal" element={<Personal />} />
          <Route path="/about" element={<About />} />
          <Route path="/playground" element={<Playground />} />
          <Route
            path="/projects/work-at-thinkmarkets"
            element={<WorkAtThinkMarkets />}
          />
          <Route path="/projects/work-at-hoody" element={<WorkAtHoody />} />
          <Route
            path="/projects/work-at-cointelegraph"
            element={<WorkAtCointelegraph />}
          />
          <Route path="/privacy" element={<PrivacyNotice />} />
          <Route path="/terms" element={<TermsOfUse />} />
        </Routes>

        {!hideLayout && <Footer />}
      </div>
    </>
  );
}

// 👇 The actual exported App with the Router wrapper
export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
